<ion-content>
  <ion-card>
    <ion-card-content>
      <mat-form-field appearance="outline" class="admia-form-item">
        <mat-label>{{ texts.order.barcodetitle }}</mat-label>
        <input
          #barcodeInputElement
          [(ngModel)]="barcodeInput"
          (input)="onInput($event)"
          (keydown.enter)="onEnter()"
          (keydown.tab)="onEnter()"
          matInput
          type="text"
          autocomplete="off"
          autocorrect="off"
          autocapitalize="off"
          spellcheck="false"
          inputmode="none"
        />
      </mat-form-field>
    </ion-card-content>
  </ion-card>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-tab-button slot="end" (click)="close()">
      <ion-icon name="arrow-back"></ion-icon>
      <ion-label>{{ texts.general.cancel | translate }}</ion-label>
    </ion-tab-button>
  </ion-toolbar>
</ion-footer>
